import { render, staticRenderFns } from "./inwardTransaction.vue?vue&type=template&id=36a062f8&"
import script from "./inwardTransaction.vue?vue&type=script&lang=js&"
export * from "./inwardTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports